import { Component, inject, OnInit } from '@angular/core';
import { DacScenarioService } from '../dac-scenarios.service';
import { DacScenariosRepository } from '@/store/dac-scenarios-state/dac-scenarios-state.repository';
import { addDacScenariosFormObject } from './utils/add-dac-scenarios-form-object';
import { DynamicForm, SelectOption } from '@/components/form-builder/form-builder.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { PassingModeService } from '../../passing-mode/passing-mode.service';
import { Button } from 'primeng/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Scenario, ScenarioDto } from '@/types/scenarios.types';
import { dacScenariosSchema } from '@/validations/dac-screnarios.validation';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
  selector: 'sm-add-dac-scenarios',
  imports: [FormBuilderComponent, PageHeaderComponent, Button, TranslateModule],
  templateUrl: './add-dac-scenarios.component.html',
  styleUrl: './add-dac-scenarios.component.scss',
})
export class AddDacScenariosComponent implements OnInit {
  dacScenarioService = inject(DacScenarioService);
  dacScenariosRepository = inject(DacScenariosRepository);
  passingModeService = inject(PassingModeService);
  messageService = inject(MessageService);
  translate = inject(TranslateService);
  router = inject(Router);

  passingModeOptions?: SelectOption[];

  breadcrumb = [
    {
      label: 'settings.dacScenarios.breadcrumb.parametres',
      routerLink: ['/settings'],
    },
    {
      label: 'settings.dacScenarios.breadcrumb.scenarios',
      routerLink: ['/settings', 'dac-scenarios'],
    },
    {
      label: 'settings.dacScenarios.add.title',
      routerLink: ['/settings', 'dac-scenarios', 'add'],
    },
  ];

  formObject: DynamicForm = addDacScenariosFormObject({
    store: this.dacScenariosRepository,
  });

  ngOnInit() {
    this.dacScenariosRepository.reset();
    this.passingModeService.list().subscribe(passingModes => {
      this.passingModeOptions = passingModes.map(passingMode => {
        return { name: passingMode.libelle, code: passingMode.id };
      });
      this.formObject = addDacScenariosFormObject({
        store: this.dacScenariosRepository,
        passingModeOptions: this.passingModeOptions,
      });
    });
  }

  addDacScenarios() {
    const dto = this.dacScenariosRepository.get<ScenarioDto>('dto');
    const result = dacScenariosSchema.safeParse(dto);
    if (result.success) {
      this.dacScenarioService.create(dto).subscribe({
        next: (data: Scenario) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Succès',
            detail: this.translate.instant('settings.dacScenarios.message.success.added'),
          });
          this.dacScenariosRepository.reset();
          this.router.navigate(['/settings', 'dac-scenarios', 'edit', data.id]);
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: this.translate.instant('settings.dacScenarios.message.error.added'),
          });
        },
      });
    } else {
      this.dacScenariosRepository.setErrors(result.error.flatten().fieldErrors);
    }
  }
}
